if (!customElements.get('menu-drawer')) {
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );
      this.querySelectorAll('button.menu-drawer__close-button').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
    }

    onSummaryClick(event) {
      const summary = event.currentTarget;
      const details = summary.parentNode;
      const isOpen = details.hasAttribute('open');
      if (!isOpen) {
        summary.setAttribute('aria-expanded', 'true');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (reduced.matches) {
          details.classList.add('menu-opening');
        } else {
          setTimeout(() => details.classList.add('menu-opening'));
        }
      } else {
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
      }
    }

    onCloseButtonClick(event) {
      const details = event.currentTarget.closest('details');
      if (details) this.closeSubmenu(details);
    }

    closeSubmenu(details) {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    close() {
      if (this.mainDetailsToggle) this.closeSubmenu(this.mainDetailsToggle);
    }
  }

  customElements.define('menu-drawer', MenuDrawer);

  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
      this.onBodyClick = this.handleBodyClick.bind(this);
    }

    handleBodyClick(evt) {
      if (evt.target.closest('header-drawer')) return;
      this.closeMenuDrawer();
    }

    onSummaryClick(event) {
      super.onSummaryClick(event);
      const details = event.currentTarget.parentNode;
      if (details === this.mainDetailsToggle) {
        if (!details.hasAttribute('open')) {
          document.body.addEventListener('click', this.onBodyClick);
        } else {
          document.body.removeEventListener('click', this.onBodyClick);
          this.querySelectorAll('details[open]').forEach((d) => {
            if (d !== this.mainDetailsToggle) this.closeSubmenu(d);
          });
        }
      }
    }

    closeMenuDrawer() {
      document.body.removeEventListener('click', this.onBodyClick);
      this.close();
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}
